import React from "react";

export default function UploadProgress({ progress, speed, eta }) {
  return (
    <div className="upload-progress-popup">
      <div className="upload-box">
        <h3>Đang tải lên...</h3>

        <div className="progress-bar">
          <div className="progress-fill" style={{ width: progress + "%" }} />
        </div>
        <div className="progress-percent">{progress.toFixed(1)}%</div>

        <div className="upload-info">
          <div className="upload-stat">
            <div className="upload-stat-label">Tiến độ</div>
            <div className="upload-stat-value">{progress.toFixed(0)}%</div>
          </div>
          <div className="upload-stat">
            <div className="upload-stat-label">Tốc độ</div>
            <div className="upload-stat-value">{speed} MB/s</div>
          </div>
          <div className="upload-stat">
            <div className="upload-stat-label">Còn lại</div>
            <div className="upload-stat-value">{eta}s</div>
          </div>
        </div>
      </div>
    </div>
  );
}
